import type {CommonProps} from './types';

export default ({color = 'currentColor', size = 24, ...rest}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    {...rest}
  >
    <g
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.75"
    >
      <path d="M6 3h12M6 21h12" />
      <path d="M7 3v3.5c0 1.6.9 2.5 2.2 3.5l2.8 2.1-2.8 2.1C7.9 15 7 15.9 7 17.5V21" />
      <path d="M17 3v3.5c0 1.6-.9 2.5-2.2 3.5L12 12.1l2.8 2.1c1.3 1 2.2 1.9 2.2 3.5V21" />
    </g>
  </svg>
);
